import React from 'react';
import * as MD from '@material-ui/core/';
import { connect } from 'react-redux';
import { IApplicationState } from '../../Store';
import { IElectionsState, IElectionsStudyType } from '../../Store/Elections/Types';
import { IDashboardState } from '../../Store/Dashboard/Types';

const styles = (theme: any) => MD.createStyles({
    formControl: {
        width: '100%',
        marginTop: '12px',
    },
    inputClasses: {
        fontSize: 'small',
        border: '1px gray'
    },
    label: {
        fontSize: 13,
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '16px',
        letterSpacing: '0px',
        textAlign: 'left',
        marginLeft: 17,
        color: theme.palette.text.primary
    }
})
interface IPropsFromDispatch {

}
interface IPropsFromState {
    elections: IElectionsState;
    dashboard: IDashboardState;
}
interface IOwnProps {
    handleElectionChange: (e: any) => void;
    electionsID: number | null;
    electionsIDArray: number[];
}

type DrawProps =
    MD.WithTheme &
    MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch &
    IOwnProps;


type ISelectState = InitialState

interface InitialState {

}

export class ElectionSelectComponent extends React.Component<DrawProps, ISelectState> {
    public constructor(props: DrawProps) {
        super(props);
    }

    public render() {
        const { classes } = this.props;
        
        // Validate that electionsID exists in available options
        const isValidElectionId = this.props.electionsID !== null && 
            this.props.elections.elections_study_types.some((x: IElectionsStudyType) => x.id === this.props.electionsID);
        const selectValue = isValidElectionId ? this.props.electionsID : "";

        return (
            <MD.FormControl
                className={this.props.classes.formControl}
                style={{ padding: '10px' }}>
                <MD.InputLabel className={classes.label}
                    style={{ marginTop: -9 }}
                    shrink={true}>
                    {"Elections"}
                </MD.InputLabel>
                <MD.Select
                    labelId="mutiple-checkbox-label"
                    id="mutiple-checkbox"
                    variant='filled'
                    onChange={(ev: any) => this.props.handleElectionChange(ev)}
                    value={selectValue}
                    input={<MD.OutlinedInput className={this.props.classes.inputClasses} />}
                    renderValue={(value: any) => {
                        let item = this.props.elections.elections_study_types.filter((x: any) => x.id === value)
                        return item[0] === undefined ? "" : item[0].name
                    }}
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        }
                    }}
                >
                    {
                        this.props.elections.elections_study_types.map((x: IElectionsStudyType) => {


                            return (
                                <MD.MenuItem
                                    key={x.id}
                                    value={x.id}
                                    disabled={this.props.dashboard.dateCloture ? new Date(x.start) > this.props.dashboard.dateCloture : undefined}
                                    style={{
                                        paddingLeft: '0px',
                                        height: '25px',
                                        backgroundColor: this.props.electionsID === x.id ? 'rgba(0, 0, 0, 0.08)' : 'inherit'
                                    }}>
                                    <MD.ListItemText style={{ paddingLeft: '10px' }} primary={x.name} />
                                </MD.MenuItem>
                            );
                        }
                        )
                    }
                </MD.Select>
            </MD.FormControl>
        )
    }
}
const mapStateToProps = ({ elections, dashboard }: IApplicationState) => ({
    elections,
    dashboard
});

export const ElectionSelect =
    connect(mapStateToProps, null)(MD.withTheme(MD.withStyles(styles)(ElectionSelectComponent)));
